module.exports = __webpack_public_path__ + "h5/img/qukuailian.9d795506.png";